function sanitizeUploadHeaders(rawHeaders) {
    var headers = {}
    if (rawHeaders && typeof rawHeaders === 'object') {
        headers = Object.assign({}, rawHeaders)
    }

    delete headers.common
    delete headers.delete
    delete headers.get
    delete headers.head
    delete headers.post
    delete headers.put
    delete headers.patch
    delete headers['Content-Type']
    delete headers['content-type']

    return headers
}

function uploadFileBySignedUrl(options) {
    var config = options || {}
    var uploadUrl = config.uploadUrl || ''
    var method = ((config.method || 'PUT') + '').toUpperCase()
    var file = config.file
    var headers = sanitizeUploadHeaders(config.headers)

    return new Promise(function (resolve, reject) {
        if (!uploadUrl) {
            reject({ message: 'uploadUrl 不能为空' })
            return
        }
        if (!file) {
            reject({ message: 'file 不能为空' })
            return
        }

        var xhr = new XMLHttpRequest()
        xhr.open(method, uploadUrl, true)
        xhr.withCredentials = false

        for (var key in headers) {
            if (!Object.prototype.hasOwnProperty.call(headers, key)) continue
            if (!key) continue
            var lowerKey = (key + '').toLowerCase()
            if (lowerKey === 'content-type') continue
            if (headers[key] === undefined || headers[key] === null || headers[key] === '') continue
            xhr.setRequestHeader(key, headers[key])
        }

        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve({
                    status: xhr.status,
                    responseText: xhr.responseText
                })
                return
            }
            reject({
                status: xhr.status,
                responseText: xhr.responseText,
                message: 'HTTP ' + xhr.status
            })
        }

        xhr.onerror = function () {
            reject({ message: '网络错误，上传失败' })
        }

        xhr.onabort = function () {
            reject({ message: '上传已取消' })
        }

        // 使用空 MIME 的 Blob，避免浏览器自动附加文件 MIME 到 Content-Type。
        var payload = file
        if (file && typeof file.slice === 'function') {
            payload = file.slice(0, file.size, '')
        }

        xhr.send(payload)
    })
}

export {
    sanitizeUploadHeaders,
    uploadFileBySignedUrl
}



// WEBPACK FOOTER //
// ./src/utils/presignedUpload.js